import { Address } from '@instamenu/context-user';

export function placeToAddress(place: google.maps.places.Place): Address | undefined {
  if (!place?.addressComponents) return undefined;

  const getComponent = (type: string, options: { short: boolean } = { short: false }) =>
    place.addressComponents?.find((c) => c.types.includes(type))?.[
      options.short ? 'shortText' : 'longText'
    ] || '';

  if (!getComponent('route')) return undefined;
  const location = place.location;
  if (!location) return undefined;

  const addressJson = {
    street: [
      getComponent('street_number'),
      getComponent('route', { short: true }),
      getComponent('subpremise'),
    ]
      .filter((part) => !!part)
      .join(' '),
    city:
      getComponent('locality') ||
      getComponent('sublocality_level_1') ||
      getComponent('neighborhood'),
    state: getComponent('administrative_area_level_1', { short: true }),
    zip: getComponent('postal_code'),
    location: { lat: location.lat(), lon: location.lng() },
  };
  return Address.fromJSON(addressJson);
}
